import React from 'react';

export function TwitterIcon({
  width = 35,
  height = 29,
  color = '#50ABF1',
}: {
  width?: number;
  height?: number;
  color?: string;
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 35 29" aria-hidden={true}>
      <title>Twitter logo</title>
      <path
        d="M10.9304552,28.6920588 C6.9036796,28.6920588 3.15556827,27.5100637 0,25.4841865 C0.557837144,25.5501287 1.12546313,25.5838636 1.70097105,25.5838636 C5.04163752,25.5838636 8.11622533,24.4423505 10.5565721,22.527353 C7.43634542,22.4696853 4.80301849,20.4053631 3.8957068,17.5685749 C4.33099266,17.6519575 4.77772004,17.6966403 5.2371602,17.6966403 C5.88754644,17.6966403 6.5174651,17.6094387 7.11585603,17.4462381 C3.8537546,16.7903804 1.39599127,13.9044539 1.39599127,10.4449064 C1.39599127,10.4148633 1.39599127,10.3849474 1.39649978,10.3551588 C2.35796794,10.8899527 3.45736986,11.2111346 4.62631073,11.2481793 C2.71303612,9.96778014 1.45408871,7.7822668 1.45408871,5.30510556 C1.45408871,3.99657273 1.80572443,2.77002211 2.41949784,1.71545592 C5.93636355,6.03530737 11.1904318,8.87795141 17.1166251,9.17570978 C16.9950908,8.65313684 16.9319083,8.10815882 16.9319083,7.54854112 C16.9319083,3.60537501 20.1245979,0.408450704 24.0626383,0.408450704 C26.1134652,0.408450704 27.9666084,1.27562899 29.2673809,2.6633434 C30.8915667,2.34305265 32.4176098,1.74880893 33.7952946,0.930641741 C33.262883,2.59791039 32.1323348,3.99720924 30.6600668,4.88093674 C32.1024597,4.70831581 33.4767121,4.32450158 34.7554915,3.75660928 C33.7994898,5.18849733 32.5905037,6.44610953 31.1974364,7.45281034 C31.2111662,7.75897061 31.2180311,8.06691311 31.2180311,8.37651053 C31.2180311,17.8119755 24.0459845,28.6920588 10.9304552,28.6920588"
        id="Twitter"
        stroke="none"
        fill={color}
        fillRule="evenodd"
      />
    </svg>
  );
}
